import {post, get} from '@/common/utils/Http';

export default {
  getTemplates: post('/schedule/getTemplates'),
  previewTpl: post('/schedule/previewTpl'),
  createRule: post('/schedule/createRule'),
  updateRule: post('/schedule/updateRule'),
  deleteRule: post('/schedule/deleteRule'),
  getRules: post('/schedule/getRules'),
  getRulesByKeyword: post('/schedule/getRulesByKeyword'),
  getAllSendCount: post('/schedule/getAllSendCount'),
  getRecordsStatistics: post('/schedule/getRecordsStatistics'),
  getAllFailureCount: post('/schedule/getAllFailureCount'),
  getFailureCount: post('/schedule/getFailureCount'),
  getRecords: post('/schedule/getRecords'),
  getProbabilityData: post('/schedule/getProbabilityData'),
  getDisableRules: post('/schedule/getDisableRules'),
};
